import { Route, Switch, withRouter } from "react-router-dom";
import Header from "../header/Header";
import routes from "../config/routes";
import { LocalizeProvider } from "../languages/Localize";
import React from "react";
import Home from "../home/Home";
import theme from "../theme/theme";
import GlobalStyle from "../components/global-styles/GlobalStyle";
import "antd/dist/antd.css";
import { ThemeProvider } from "styled-components";
import Menu from "../menu/Menu";
import Sponsors from "../sponsors/Sponsors";
import Location from "../location/Location";
import Panels from "../panels/Panels";
import Speakers from "../speakers/Speakers";
import ApplicationProvider from "../application/Application";
import styled from "styled-components";
import { Box } from "reflexbox/styled-components";
import FavoriteProvider from "../favorite/Favorite";
import Panel from "../panels/panel/Panel";
import Speaker from "../speakers/Speaker";
import RenderIf from "../common/conditions/RenderIf";
import HomeFooter from "../home/home-footer/HomeFooter";
import PanelImpression from "../panels/panel/panel-impression/PanelImpression";
import RegisterContainer from "../register/RegisterContainer";
import RegisterDone from "../register-done/RegisterDone";
import PanelImpressionDone from "../panels/panel/panel-impression-done/PanelImpressionDone";
import FavoritePanels from "../panels/favorite/FavouritePanels";
import SuccessfulPaymentInterceptor from "../register/payment-gateway/SuccessfulPaymentInterceptor";
import SuccessfulPayment from "../register/register-content/e-payment/SuccessfulPayment";
import FailPayment from "../register/register-content/e-payment/FailPayment";

const StyledContentBox = styled(Box)`
    position: absolute;
    z-index: 5;
    height: ${props => (props.withNavigation ? `calc( 100vh - 17% - 56px );` : `calc( 100vh - 17% - 70px)`)};
    width: 100%;
    top: 17%;
`;

const Main = ({ location: { pathname: path } }) => {
    return (
        <>
            <ThemeProvider theme={theme}>
                <GlobalStyle />
                <LocalizeProvider>
                    <ApplicationProvider>
                        <FavoriteProvider>
                            <Header />
                            <StyledContentBox withNavigation={path !== routes.HOME}>
                                <Switch>
                                    <Route exact path={routes.HOME} component={Home} />
                                    <Route exact path={routes.REGISTER} component={RegisterContainer} />
                                    <Route exact path={routes.PANELS} component={Panels} />
                                    <Route exact path={routes.PANELS_FAVORITE} component={FavoritePanels} />
                                    <Route exact path={routes.SPEAKERS} component={Speakers} />
                                    <Route exact path={routes.SPONSORS} component={Sponsors} />
                                    <Route exact path={routes.LOCATION} component={Location} />
                                    <Route exact path={routes.REGISTER_DONE} component={RegisterDone} />
                                    <Route exact path={`${routes.PANELS_DETAILS}:id`} component={Panel} />
                                    <Route exact path={routes.PANELS_IMPRESSION_DONE} component={PanelImpressionDone} />
                                    <Route exact path={routes.SUCCESSFUL_PAYMENT_FORWARD} component={SuccessfulPaymentInterceptor} />
                                    <Route exact path={`${routes.PANELS_IMPRESSION}:id`} component={PanelImpression} />
                                    <Route exact path={`${routes.SPEAKERS_DETAILS}:id`} component={Speaker} />
                                    <Route exact path={routes.SUCCESSFUL_EPAYMENT} component={SuccessfulPayment} />
                                    <Route exact path={routes.FAIL_EPAYMENT} component={FailPayment} />
                                </Switch>
                            </StyledContentBox>
                            <RenderIf render={() => <Menu />} if={path !== routes.HOME} />
                            <RenderIf render={() => <HomeFooter />} if={path === routes.HOME} />
                        </FavoriteProvider>
                    </ApplicationProvider>
                </LocalizeProvider>
            </ThemeProvider>
        </>
    );
};

export default withRouter(Main);
